<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            个人交易明细
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList' ref="search">
                        <template slot="daterange">
                            <Daterange :startTime="searchForm.startTime" :endTime="searchForm.endTime" @dataChange='dataChange'></Daterange>
                        </template>
                    </Search>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table v-loading="tableLoading" :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column prop="serialNumber" label="订单号"></el-table-column>
                        <el-table-column prop="receiveName" label="老人姓名"></el-table-column>
                        <el-table-column prop="receivePhone" label="手机号"></el-table-column>
                        <el-table-column prop="payTime" :formatter="timefilter" width="200" label="付款时间"></el-table-column>
                        <!-- <el-table-column prop="completeTime" :formatter="timefilter" width="200" label="完成时间"></el-table-column> -->
                        <el-table-column prop="status" :formatter="statusTitle" width="105" label="订单状态"></el-table-column>
                        <el-table-column prop="orderFrom" label="订单来源"></el-table-column>
                        <el-table-column prop="businessName" label="商家名称"></el-table-column>
                        <el-table-column prop="payType" label="付款类型"></el-table-column>
                        <el-table-column prop="price" label="订单金额(元)"></el-table-column>
                    </el-table>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {timeStr,getMonthDay,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import Search from "@/components/Search";
    import Daterange from "@/components/Daterange";
    export default{
        data(){
            return{
                tableLoading:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                searchForm:{
                    ReceiveName:'',
                    ReceivePhone:'',
                    startTime:'',
                    endTime:'',
                }
            }
        },
        components:{
            Daterange,Search
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){
                this.searchData=[
                    {span:12,name:'老人姓名',value:'ReceiveName',type:'input',options:this.ReceiveName},
                    {span:12,name:'手机号',value:'ReceivePhone',type:'input',options:this.ReceivePhone},
                    {span:24,name:'起止时间',width:495,value:'daterange',type:'slot'},
                ]
                this.searchForm.endTime = getMonthDay('e', 0)
                this.searchForm.startTime = getMonthDay('s', 0)
            },
        
            noAccountingRecord(){
                this.showModalStayInfo=true
                this.$refs.myStayInfo.init();
            },
            // statuss(row, column, cellValue) {
            //     return this.allStatus(cellValue, ['待付款', '待发货', '待收货', '交易成功', '退款中', '交易关闭', '交易取消', '已评价', "", "", '待付款', '待接单', '已接单', '服务中', '服务完成', '交易取消', '已评价']);
            // },
            //日期格式
            timefilter(row, column, cellValue) {
                 if (cellValue) {
                 return timefilters(cellValue)
                }
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            dataChange(val){
                this.searchForm.startTime=val[0]
                this.searchForm.endTime=val[1]
            },
            getList(isSearch) {
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableLoading=true
                
                // console.log(getStaffDTO().businessCode)
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                }
                Object.assign(data,this.searchForm)
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Order/GetOrderbusiness",
                    data: data,
                    // businessCode:businessCode
                }).then( (response)=> {
                    this.tableLoading=false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },
            statusTitle(row) {
                if (row.status === 0) {
                    return "待付款";
                }
                if (row.status === 1) {
                    return "待发货";
                }
                if (row.status === 2) {
                    return "待收货";
                }
                if (row.status === 3) {
                    return "交易成功";
                }
                if (row.status === 4) {
                    return "退款中";
                }
                if (row.status === 5) {
                    return "交易关闭";
                }
                if (row.status === 6) {
                    return "交易取消";
                }
                if (row.status === 7) {
                    return "已评价";
                }
                if (row.status === 10) {
                    return "待付款";
                }
                if (row.status === 11) {
                    return "待接单";
                }
                if (row.status === 12) {
                    return "已接单";
                }
                if (row.status === 13) {
                    return "服务中";
                }
                if (row.status === 14) {
                    return "服务完成";
                }
                if (row.status === 15) {
                    return "交易取消";
                }
                if (row.status === 16) {
                    return "已评价";
                }
                if (row.status === 17) {
                    return "已删除";
                }
                return "其它";
            },
        }
    }

</script>

<style lang="scss" scoped>
    .bankInfo{
        line-height: 30px;
        font-size: 16px;
        margin-top: 10px;
        color: #333;
    }
    .inputMoneyNumber /deep/ .el-input__inner{
        text-align: left;
    }
    .bankPrice{
        margin-top: 10px;
        span{
            line-height: 30px;
            margin-left: 5px;
        }
    }
</style>